import "./HomeLanding.scss";
import { useState } from "react";
import Btn from "../../../components/btn/Btn";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";
import { paths } from "../../../utils/paths";
import { baseUrl } from "../../../utils/apiData";
import {images} from "../../../utils/images";

const HomeLanding = ({ dataList }) => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };

  return (
    <section className="home_landing">
      <div className="content_wrap">
        {dataList?.map((data, k) => {
          return (
            activeIndex === k && (
              <div
                className="landing_content"
                onClick={(e) => e.stopPropagation()}
                key={k}
              >
                <motion.p
                  initial={{ translateX: 32, opacity: 0 }}
                  whileInView={{ translateX: 0, opacity: 1 }}
                  transition={{ duration: 0.6, ease: "easeInOut" }}
                  viewport={{ once: true }}
                  className="tag_title p_t"
                >
                  <span>_</span>
                  {data?.heading}
                </motion.p>
                <motion.h1
                  initial={{ translateY: 32, opacity: 0 }}
                  whileInView={{ translateY: 0, opacity: 1 }}
                  transition={{ duration: 0.6, ease: "easeInOut", delay: 0.15 }}
                  viewport={{ once: true }}
                >
                  {data?.title}
                </motion.h1>
                <Btn
                  title="Know More"
                  delay={0.3}
                  onClick={() => navigate(`${paths.ABOUT}`)}
                />
                <div className="big_para">
                  <img src={images.bgLogo} alt="Logo" />
                  <p className="t_18">{data?.description}</p>
                </div>
              </div>
            )
          );
        })}

        <div className="home_slider_sec">
          <Swiper
            direction={"vertical"}
            autoplay={{
              delay: 6000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            onSlideChange={handleSlideChange}
            modules={[Pagination, Autoplay]}
            className="mySwiper"
          >
            {dataList?.map((data) => {
              return (
                  <SwiperSlide key={data?._id}>
                    <div className="img_wrap">
                      <img src={`${baseUrl}/${data?.image}`} alt="Home" />
                    </div>
                  </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};
export default HomeLanding;
